// src/pages/AdminLoginPage.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../config';
import './AdminLoginPage.css';

export default function AdminLoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false); // 로딩/중복 제출 방지
  const navigate = useNavigate();

  // 이미 로그인 상태면 바로 관리자 페이지로
  useEffect(() => {
    if (localStorage.getItem('isAdmin') === 'true') {
      navigate('/admin', { replace: true });
    }
  }, [navigate]);

  const handleLogin = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);

    try {
      const res = await fetch(`${API_BASE_URL}/api/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });

      if (res.ok) {
        localStorage.setItem('isAdmin', 'true');
        navigate('/admin', { replace: true });
      } else if (res.status === 401) {
        alert('로그인 실패: 아이디 또는 비밀번호를 확인하세요.');
      } else {
        alert(`로그인 실패 (HTTP ${res.status})`);
      }
    } catch (err) {
      console.error(err);
      alert('서버 오류가 발생했습니다.');
    } finally {
      setIsSubmitting(false);
    }
  };

  // Enter로도 제출되게 form 사용
  const onSubmit = (e) => {
    e.preventDefault();
    handleLogin();
  };

  return (
    <div className="login-page">
      <div className="login-box">
        <h2>관리자 로그인</h2>
        <form onSubmit={onSubmit}>
          <input
            type="text"
            placeholder="아이디"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            disabled={isSubmitting}
            autoComplete="username"
          />
          <input
            type="password"
            placeholder="비밀번호"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={isSubmitting}
            autoComplete="current-password"
          />
          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? '로그인 중…' : '로그인'}
          </button>
        </form>
      </div>
    </div>
  );
}